/** Strong / OK / Weak — the one question that changes how much time a chapter
 * gets: weak earns +30 min, ok nothing, strong gives 15 min back. */
export function ConfidencePicker({ value, onChange, testId, disabled }) {
  const current = (value || '').toLowerCase();
  const options = [
    ['strong', 'Strong', 'bg-emerald-500 border-emerald-500'],
    ['ok', 'OK', 'bg-amber-500 border-amber-500'],
    ['weak', 'Weak', 'bg-rose-500 border-rose-500'],
  ];
  return (
    <span className="inline-flex rounded-full border border-slate-200 overflow-hidden flex-shrink-0" data-testid={testId}>
      {options.map(([key, label, active]) => (
        <button key={key} type="button" disabled={disabled}
          data-testid={`${testId}-${key}`}
          onClick={() => onChange(current === key ? 'ok' : key)}
          className={`px-2.5 py-1 text-[11px] font-heading transition-colors ${
            current === key ? `${active} text-white` : 'bg-white text-slate-500 hover:bg-slate-50'}`}>
          {label}
        </button>
      ))}
    </span>
  );
}

export default ConfidencePicker;
